'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetDataReceived = undefined;

var _bootstrapWidget = require('./bootstrapWidget');

var _bootstrapWidget2 = _interopRequireDefault(_bootstrapWidget);

var _initializeI18n = require('./initializeI18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetDataReceived = exports.widgetDataReceived = function widgetDataReceived(_ref) {
  var data = _ref.data,
      parsedData = _ref.parsedData,
      rawData = _ref.rawData;
  return function (dispatch) {
    if (data) {
      dispatch((0, _initializeI18n.initializeI18n)({ data: data })).then(function () {
        dispatch((0, _bootstrapWidget2.default)(data));
      }, function () {
        dispatch((0, _bootstrapWidget2.default)(data));
      });
    } else {
      window.Raven.captureMessage('RECEIVED_INVALID_WIDGET_DATA', {
        extra: {
          rawData: rawData,
          parsedData: parsedData
        }
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/widgetDataReceived.js
// module id = 907
// module chunks = 2 3